"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  if (!state[props.entity.plural]) console.error(`There is no ${props.entity.plural} in state. Maybe you have forgotten to register the reducer.`);
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  const {
    actions
  } = props;
  return {
    getAll: (0, _redux.bindActionCreators)(actions.getAll, dispatch),
    flip: (0, _redux.bindActionCreators)(actions.flip, dispatch),
    jump: (0, _redux.bindActionCreators)(actions.jump, dispatch),
    limit: (0, _redux.bindActionCreators)(actions.limit, dispatch),
    filter: (0, _redux.bindActionCreators)(actions.filter, dispatch),
    select: (0, _redux.bindActionCreators)(actions.select, dispatch),
    selectAll: (0, _redux.bindActionCreators)(actions.selectAll, dispatch),
    destroyBatch: (0, _redux.bindActionCreators)(actions.destroyBatch, dispatch),
    closeError: (0, _redux.bindActionCreators)(actions.closeError, dispatch),
    orderBy: (0, _redux.bindActionCreators)(actions.orderBy, dispatch),
    destroyFilter: (0, _redux.bindActionCreators)(actions.destroyFilter, dispatch),
    destroyAllFilters: (0, _redux.bindActionCreators)(actions.destroyAllFilters, dispatch)
  };
};
class BaseList extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleGet", () => {
      const {
        expand
      } = this.props[this.props.entity.plural];
      const {
        limit,
        page,
        filters,
        order
      } = this.props[this.props.entity.plural].list;
      const offset = limit * page;
      const params = {
        ...(expand ? {
          expand: expand
        } : {}),
        ...(limit ? {
          limit: limit
        } : {}),
        ...(offset ? {
          offset: offset
        } : {}),
        ...(filters ? {
          filter: (0, _helpers.mapFiltersToString)(filters)
        } : {}),
        ...(order ? {
          orderBy: (0, _helpers.mapSortingParamsToString)(order)
        } : {})
      };
      return this.props.getAll(params, module);
    });
    _defineProperty(this, "render", () => {
      const {
        children,
        entity,
        flip,
        jump,
        limit,
        filter,
        select,
        selectAll,
        destroyBatch,
        closeError,
        orderBy,
        destroyFilter,
        destroyAllFilters,
        [this.props.entity.plural]: store,
        ...rest
      } = this.props;
      const {
        order
      } = this.props[this.props.entity.plural].list;
      return _react.default.Children.map(children, child => _react.default.cloneElement(child, {
        ...rest,
        [entity.plural]: store,
        entity,
        schema: store.list.schema,
        onFlip: flip,
        onJump: jump,
        onLimit: limit,
        onFilter: filter,
        onSelect: select,
        onSelectAll: selectAll,
        onDelete: destroyBatch,
        onSort: orderBy,
        order: order,
        onDeleteFilter: destroyFilter,
        onDeleteAllFilters: destroyAllFilters,
        onErrorRead: id => closeError(id, 'list')
      }));
    });
  }
  componentDidMount() {
    if (!this.props[this.props.entity.plural].list.fetched) this.handleGet();
  }
  componentDidUpdate(prevProps) {
    if (prevProps[this.props.entity.plural].list.page !== this.props[this.props.entity.plural].list.page || prevProps[this.props.entity.plural].list.limit !== this.props[this.props.entity.plural].list.limit || prevProps[this.props.entity.plural].list.filters !== this.props[this.props.entity.plural].list.filters || prevProps[this.props.entity.plural].list.order !== this.props[this.props.entity.plural].list.order) this.handleGet();
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BaseList);
module.exports = exports.default;